import './helper/flexible.css'
import 'src/helper/flexible.js'
import 'src/core/index'
import './index.less'



// WEBPACK FOOTER //
// src/index.js